import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChessQueen } from "@fortawesome/free-regular-svg-icons";
import "./LandingSections.css";

const FlexibleTraining = () => {
  return (
    <section className="flexible-training-section">
      <div className="container">
        <h2>Training Built Around Your Life</h2>
        <p>
          Your schedule shouldn't be an obstacle to improvement. Our training
          programs are designed for maximum flexibility to ensure learning fits
          seamlessly into your routine.
        </p>
        <div className="training-options-container">
          <div className="training-option-card">
            <FontAwesomeIcon icon={faChessQueen} size="2x" />
            <h3>Online Mastery</h3>
            <p>
              Access our entire curriculum, live coaching sessions, and PGN
              analysis tools from anywhere in the world. Learn at your own pace
              with a flexible schedule.
            </p>
          </div>
          <div className="training-option-card">
            <FontAwesomeIcon icon={faChessQueen} size="2x" />
            <h3>Local & Private Coaching</h3>
            <p>
              For students within Nairobi and its environs, we offer intensive{" "}
              <strong>in-person lessons</strong> and group classes, including
              specialized programs for children.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FlexibleTraining;
